import { render, staticRenderFns } from "./SingleSelectResult.vue?vue&type=template&id=4a00921d&"
import script from "./SingleSelectResult.vue?vue&type=script&lang=js&"
export * from "./SingleSelectResult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports